(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kluck-ai-section-1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('main-product-image');
  const thumbnails = document.querySelectorAll('.product-two-panel__thumbnail');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      mainImage.src = thumb.dataset.full;
    });
  });

  // Scroll arrows
  const prev = document.querySelector('.thumb-prev');
  const next = document.querySelector('.thumb-next');
  const container = document.querySelector('.product-two-panel__thumbnails');

  next.addEventListener('click', () => {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  });

  prev.addEventListener('click', () => {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
